/**
 * The one place that picks what a preview or a display-only reader reads:
 * the server card while it matches the content, else the full content when
 * loaded (streaming deltas, local edits, a backend without cards), else the
 * card. Both have the same schema, so readers treat the result as content.
 */
import type { FrameData } from "@/lib/frame-data";

type PreviewFields = Pick<
  FrameData,
  "content" | "card" | "cardVersion" | "contentVersion" | "contentState"
>;

const EMPTY: Record<string, unknown> = {};

export function previewSource(frame: PreviewFields): Record<string, unknown> {
  const { card } = frame;
  if (card && frame.cardVersion === (frame.contentVersion ?? 0)) return card;
  if ((frame.contentState ?? "full") === "full") return frame.content ?? EMPTY;
  return card ?? EMPTY;
}
